/* eslint-disable react-hooks/exhaustive-deps */
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { TextField } from '@mui/material';
import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';

import { Icons } from '../../../assets/SvgIcons';
import { ICTask } from '../../../helper/Interfaces';
import classes from './DotDateCard.module.css';
import { useAppDispatch, useAppSelector } from '@Store/hooks';
import { ComponentHelper } from '@Helper/Infra';
import {
  getPricingType,
  postShowTrialEndModal,
} from '@Store/feature/pricingSlice';

type DotDateCardProps = {
  color: string;
  value: Date | undefined;
  handleClick?: (dotDate: Date) => void;
  isEditable: boolean;
  setValue?: (value: any) => void;
  updateTaskDate?: (currentTask: ICTask, taskDate: string) => void;
  task?: ICTask;
  type?: 'small';
  disabled?: boolean;
};

export const DotDateCard: FC<DotDateCardProps> = ({
  value,
  color,
  handleClick,
  isEditable,
  setValue,
  updateTaskDate,
  task,
  type,
  disabled,
}) => {
  const [dateEditMode, setDateEditMode] = useState<boolean>(false);
  const [date, setDate] = useState<Date | null>(value ? value : null);
  const componentHelper = new ComponentHelper();
  const dispatch = useAppDispatch();
  const pricingReducer = useAppSelector(getPricingType);
  const isTrialEnd = componentHelper.isDealspaceTrialEnd(pricingReducer);

  useEffect(() => {
    if (
      task &&
      task.task?.dueDate &&
      typeof task.task.dueDate === 'string' &&
      task.task.dueDate.includes('T')
    ) {
      setDate(moment(task.task.dueDate.split('T')[0]).toDate());
    } else if (
      task &&
      task.dueDate &&
      typeof task.dueDate === 'string' &&
      task.dueDate.includes('T')
    ) {
      setDate(moment(task.dueDate.split('T')[0]).toDate());
    } else {
      if (value) {
        if (task?.dueDate) {
          setDate(moment(value).toDate());
        } else {
          setDate(null);
        }
      } else {
        setDate(null);
      }
    }
  }, [task]);

  useEffect(() => {
    setDate(value || null);
  }, [value]);

  return (
    <>
      {isEditable ? (
        <>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              disabled={disabled}
              className={'dateInput'}
              views={['year', 'month', 'day']}
              inputFormat="MM/dd/yyyy"
              mask=""
              disableMaskedInput
              //clearable={true}
              // inputRef={inputReference}
              componentsProps={{
                // pass props `actions={['clear']}` to the actionBar slot
                actionBar: { actions: ['clear'] },
              }}
              value={date}
              open={dateEditMode}
              onChange={(newValue: any) => {
                if (newValue) {
                  //setValue(new Date(newValue));
                  setDate(moment(newValue.$d).toDate());
                  if (task && updateTaskDate) {
                    updateTaskDate(
                      task,
                      moment(newValue.$d).format('YYYY-MM-DD')
                    );
                  }
                } else if (newValue === null) {
                  //setValue(null);
                  setDate(null);
                  if (task && updateTaskDate) {
                    updateTaskDate(task, '');
                  }
                }
              }}
              onAccept={() => {
                setDateEditMode(false);
              }}
              onClose={() => {
                setDateEditMode(false);
              }}
              renderInput={(params: any) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <TextField
                    //onBlur={() => setDateEditMode(true)}
                    style={{ visibility: 'hidden', height: 0, width: 0 }}
                    {...params}
                  />
                  {date ? (
                    <div
                      className={classes.circle}
                      style={{
                        backgroundColor: color,
                        opacity: isEditable ? '1' : '0.5',
                      }}
                    >
                      <div className={classes.innercircle}></div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {date ? (
                    <span
                      className={classes.date}
                      onClick={() => {
                        if (isTrialEnd) {
                          dispatch(postShowTrialEndModal(true));
                          return;
                        }
                        setDateEditMode(true);
                      }}
                      //style={{ marginRight: 35, marginTop: 5 }}
                    >
                      {moment(date).format('MM/DD/yyyy')}
                    </span>
                  ) : (
                    <button
                      className="button-round-dashed"
                      style={{ opacity: isEditable ? '1' : '0.5' }}
                      onClick={() => setDateEditMode(true)}
                      disabled={disabled}
                    >
                      <Icons.Calendar />
                    </button>
                  )}
                </div>
              )}
            />
          </LocalizationProvider>
        </>
      ) : (
        <>
          {date ? (
            <div
              className={[
                classes.circle,
                type === 'small' && classes.circleSmall,
              ].join(' ')}
              style={{ backgroundColor: color }}
            >
              <div className={classes.innercircle}></div>
            </div>
          ) : (
            <></>
          )}
          {date ? (
            <span
              className={classes.date}
              onClick={() => {
                if (isTrialEnd) {
                  dispatch(postShowTrialEndModal(true));
                  return;
                }
                if (isEditable) {
                  return;
                } else {
                  setDateEditMode(true);
                }
              }}
              style={{
                marginRight: 15,
                fontSize: type === 'small' ? '12px' : 'inherit',
              }}
            >
              {moment(date).format('MM/DD/yyyy')}
            </span>
          ) : (
            <button
              className="button-round-dashed"
              style={{ marginTop: 6, opacity: isEditable ? '1' : '0.5' }}
              disabled={disabled}
            >
              <Icons.Calendar />
            </button>
          )}
        </>
      )}
    </>
  );
};
